// extracted by mini-css-extract-plugin
export default {"button":"IconButton_button__KnOPo","size_small":"IconButton_size_small__dQ-Yb","size_medium":"IconButton_size_medium__40k0V"};